module.exports = __webpack_public_path__ + "static/img/main4_7.ba96ee29.png";